import { PrimerLogoIcon } from '@primerai/icons';
import { AppSwitcherConfig } from './types';
import config from '~/config';

export const GROUP = {
  FULL: 1,
  MINIMAL: 2,
};

export const appSwitcherMenuConfig = [
  {
    id: 'Analyze',
    className: 'analyze',
    icon: PrimerLogoIcon,
    text: 'Analyze',
    url: config.PRIMER_ANALYZE_URL,
    featureFlags: ['AnalyzeAccess'],
    group: GROUP.FULL,
    description:
      'Find answers to critical questions quickly, monitor updates in real time, and automatically generate easy-to-read reports.',
  },
] as AppSwitcherConfig[];
